<script>
    import { createEventDispatcher } from 'svelte';
    import { formatValue, cleanValue } from '../helpers/format.helper';

    const dispatch = createEventDispatcher();

    export let value = '';
    export let format = 0;
    export let id;
    export let xdata = {};
    export let hrData = {};
    export let customClass = '';
    export let type = "text";
    export let selectOptions = [];
    export let changed = false;
    let defaultValue = value;

    let oldValue = '', selected = false;

    function handleKPIClick(event, value) {
        let div = event.target;
        jQuery(div).addClass('edit-mode-cell');
        oldValue = value;
        div.innerText = value;
        div.contentEditable = true;
        div.focus();
        window.getSelection()
            .selectAllChildren(div);
    }

    function handleKPIKeyDown(event, f) {
        const keyCode = event.keyCode;

        if (keyCode == 13 || keyCode == 9) {
            event.preventDefault();
            let div = event.target;
            div.contentEditable = false;
        }
        if (keyCode == 27) {
            event.preventDefault();
            let div = event.target;
            div.innerText = value;
            div.contentEditable = false;
        }
        event.stopPropagation();
    }

    function handleKPIBlur(event, f) {
        let div = event.target;

        if (jQuery(div).hasClass('cellPasted')) {
            event.preventDefault();
            event.stopPropagation();

            var values = div.innerText.toString();

            div.innerText = formatValue(f, values.split('\n')[0].split('\t')[0]);
            div.contentEditable = false;
            jQuery(div).removeClass('cellPasted');
        } else {
            if (jQuery(div).hasClass('edit-mode-cell')) {
                jQuery(div).removeClass('edit-mode-cell');
                value = cleanValue(f, div.innerText);

                dispatch('change', { value: value });
                div.innerText = formatValue(f, value);
                div.contentEditable = false;
                selected = true;
            }
        }
    }

    function selectOption(value, typeDate = false){
        if(typeDate && value){
            let validYear = value.split("-").filter(element => element.length == 4);
            if(parseInt(validYear[0]) < 999){
                return false;
            }
        }
        defaultValue = value; // change to input type date
        changed = true;
        dispatch('change', { value: value });
    }

    function changeDataDate(valueSelected){
        if (!valueSelected){
            if(jQuery('#' + id)[0] && jQuery('#' + id)[0].children[0]){
                const input = jQuery('#' + id)[0].children[0];
                jQuery(input).val('');
            }
        }else if(value.split("-").filter(element => element.length == 4).length == 0){
            // return false;
        }
        selectOption(valueSelected);
    }

</script>

{#if type == "text"}
    <div id={id} on:dblclick={(e) => handleKPIClick(e, value )}
     on:keydown={(e) => handleKPIKeyDown(e, format)}
     on:blur={(e) => handleKPIBlur(e, format)}
     contentEditable="false"
     data-id="{xdata.id}" data-report="{xdata.report}" data-date="{xdata.date}" data-field="{xdata.field}" data-value="{xdata.value}"
     data-attainment_header={xdata.attainment_header}
     data-hr-staff="{hrData.staff}" data-hr-candidate="{hrData.candidate}" data-hr-census="{hrData.census}" data-hr-year="{hrData.year}"
     data-hr-key="{hrData.key}" data-hr-model="{hrData.model}" data-hr-format="{hrData.format}" data-hr-staffingBudgetId="{hrData.staffing_budget_staff_id}"
     class="isEditable {customClass} {selected?'cellSelected':''}">
        {formatValue(format, value)}
     </div>
{:else if type == "select"}
    <div id={id}
      data-hr-staff="{hrData.staff}" data-hr-candidate="{hrData.candidate}" data-hr-census="{hrData.census}" data-hr-year="{hrData.year}"
      data-hr-key="{hrData.key}" data-hr-model="{hrData.model}" data-hr-format="{hrData.format}" data-hr-staffingBudgetId="{hrData.staffing_budget_staff_id}"
      class="isEditable {selected?'cellSelected':''}">
        <select bind:value={value} class="hr-cell hr-select" data-original-select-id="{id}"
            on:change={(e) => selectOption(e.target.value)} >
            <option value="0"></option>
            {#each selectOptions as option}
                <option value={option.option}>{option.option}</option>
            {/each}
        </select>
     </div>
{:else if type == "date"}
    <div id={id}
      data-hr-staff="{hrData.staff}" data-hr-candidate="{hrData.candidate}" data-hr-census="{hrData.census}"
      data-hr-key="{hrData.key}" data-hr-model="{hrData.model}" data-hr-format="{hrData.format}"
      class="isEditable {selected?'cellSelected':''}">
        {#if (value && defaultValue != null) || (defaultValue && changed)}
            <input type="date" bind:value={value} class="hr-cell" on:change={(e) => selectOption(e.target.value, true)}>
        {:else}
            <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" bind:value={value} class="hr-cell" on:change={(e) => selectOption(e.target.value, true)}>
        {/if}
     </div>
{/if}

<style>
    select{
        padding-top: 0px;
    }
</style>